import { keys, reduce, isNil } from 'lodash';
import { DeclarationForm } from '@models/SIO/Declaration.model';
import { IError } from '@utils/useForm';

export const validate = (values: DeclarationForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'policy':
    case 'summary':
    case 'term':
    case 'ped':
    case 'benefit':
    case 'assured':
    case 'completed':
    case 'understand':
      if (isNil(value) || value === false) {
        error = {isValid: false};
      }
      break;
  }
  return error;
}